<template>
	<div style="display: none; height: auto; position: absolute">

		<div class="imgContainer" v-for="(img,index) in imgArrayNow" :key="index">
			<img :src="baseUrl + img" style="width:50px;height: 50px;">
		</div>

		<div class="imgContainer" v-for="(img,index) in imgArrayNext" :key="index">
			<img :src="baseUrl + img" style="width:50px;height: 50px;">
		</div>

	</div>
</template>

<script>

	import { url} from '../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		props:[],
		beforeMount(){
			this.setPreloadAssets(this.currentBlock);
		},



		data(){
			return {
				baseUrl : url,
				imgArrayNow: [],
				imgArrayNext: [],
			}
		},

		watch: {
			currentBlock: function (val)
			{
				this.setPreloadAssets(val);
			},
		},

		methods:{
			...mapActions([
				'loadAudio'
			]),

			setPreloadAssets(currentBlock){
				//console.log("Preload: " + currentBlock);
				if(currentBlock == 0) this.loopThroughProperties(this.blocks[currentBlock] , true);
				else this.imgArrayNow = this.imgArrayNext.slice();
				this.imgArrayNext = [];
				this.loopThroughProperties(this.blocks[currentBlock+1] , false);
			},

			loopThroughProperties(obj, current){
				for (var propertyName in obj) {
					if (obj.hasOwnProperty(propertyName)) {

						let property = obj[propertyName];
						if(property == null) continue;

						if(propertyName == "visual") this.handleVisualByExtension(property , current);
						//if(propertyName == "background") this.handleVisualByExtension(property , current);
						if(propertyName == "intro_background") this.handleVisualByExtension(property , current);
						if(this.isArray(property)){
							property.forEach((entry)=>{
								this.loopThroughProperties(entry ,current);
							});
						}
						else if(this.isObject(property)){
							this.loopThroughProperties(property, current);
						}
					}
				}
			},

			isObject(obj){
				return obj === Object(obj);
			},

			isArray(obj){
				return obj.constructor === Array;
			},

			handleVisualByExtension(visual, current){

				let fileExtension = visual.substr(visual.lastIndexOf('.') + 1);

				switch(fileExtension.toLowerCase()){
					case "svg":
					case "png":
					case "jpg":
					case "gif":
						if(current){
							if(this.imgArrayNow.indexOf(visual) == -1) this.imgArrayNow.push(visual);
						}
						else{
							if(this.imgArrayNext.indexOf(visual) == -1) this.imgArrayNext.push(visual);
						}
						break;
				}

			},
		},
		computed:{
			...mapGetters(["blocks","currentBlock"]),
		},

	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Preloader.vue